import {observable, action} from 'mobx';
import modalAction from '~/utils/modalStack';

const {pushStack, popStack} = modalAction;
class Store {
  @observable showNotification;

  @observable showMenuBar = false;

  @observable themeModalVisible = false;

  @observable showAllProfileInfo = false;

  @observable showExpandArea = false;

  @observable showAdminInfo = false;

  @action.bound
  toggleNotification() {
    this.showNotification = !this.showNotification;
  }

  @action.bound
  toggleMenuBarDrawer(boolean) {
    this.showMenuBar = boolean;
    if (boolean) {
      pushStack(() => this.toggleMenuBarDrawer(false));
    } else {
      popStack();
    }
  }

  @action.bound
  setThemeModalVisibility(boolean) {
    this.themeModalVisible = boolean;
  }

  @action.bound
  setShowAllProfileInfo(boolean) {
    this.showAllProfileInfo = boolean;
  }

  @action.bound
  setShowExpandArea(boolean) {
    this.showExpandArea = boolean;
  }

  @action.bound
  setShowAdminInfo(boolean) {
    this.showAdminInfo = boolean;
  }
}

export default new Store();
